export default "__VITE_PUBLIC_ASSET__771b867c__"